module.exports = __webpack_public_path__ + "img/听说@2x.456e6a1b.png";